/**
 * ページ読み込み完了時にbodyに.loadedクラスを付与
 * すべてのリソース（画像、スタイルシートなど）の読み込み完了後に実行される
 */
export const addLoadedClass = () => {
  window.addEventListener('load', () => {
    document.body.classList.add('loaded');
  });
};
